import React, { useEffect, useState, Component } from 'react';
import { ShieldCheck, AlertTriangle, Sparkles, Star, Gift, CheckCircle2, ChevronDown, Clock, ArrowRight } from 'lucide-react';
const HERO_BG = 'https://cdn.magicpatterns.com/uploads/jNuoJGyJDgzmoWaa4e47mX/Gemini_Generated_Image_ee8c6dee8c6dee8c.png';
const REVELATION_IMG = 'https://cdn.magicpatterns.com/uploads/4nmFUCu3H8nPe5AqFzm3iy/Gemini_Generated_Image_loawgoloawgoloaw.png';
export function SantuarioLanding() {
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-amber-500/30" data-id="element-2">
      <CountdownBanner data-id="element-3" />
      <HeroSection data-id="element-4" />
      <HookSection data-id="element-5" />
      <RevelationSection data-id="element-6" />
      <TestimonialSection data-id="element-7" />
      <OfferSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FooterCTA data-id="element-11" />
    </div>;
}
function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="sticky top-0 z-50 bg-red-700 text-white px-4 py-2 shadow-lg shadow-red-900/20 border-b border-red-500/50 pt-[1px] pb-[1px] pl-[12px] pr-[12px]" data-id="element-12">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left text-sm sm:text-base font-medium" data-id="element-13">
        <div className="flex items-center gap-2" data-id="element-14">
          <Clock className="w-5 h-5 animate-pulse text-red-200" data-id="element-15" />
          <span data-id="element-16">
            ¡OFERTA POR TIEMPO LIMITADO! Obtené el Manual + 5 Bonos GRATIS.
          </span>
        </div>
        <div className="flex items-center gap-2 bg-red-950/50 px-3 py-1 rounded-md font-bold tracking-wider border border-red-500/30" data-id="element-17">
          Expira en:
          <span className="text-amber-300" data-id="element-18">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
        </div>
      </div>
    </div>;
}
function HeroSection() {
  return <section className="relative min-h-[70vh] flex items-center justify-center pt-8 pb-10 px-4 overflow-hidden" data-id="element-19">
      <div className="absolute inset-0 z-0" data-id="element-20">
        <img src={HERO_BG} alt="Santuario Blindado Manual y Elementos" className="w-full h-full object-cover object-center opacity-40" data-id="element-21" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-slate-950/60 to-slate-950" data-id="element-22"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(251,191,36,0.05)_0%,transparent_70%)]" data-id="element-23"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center space-y-5" data-id="element-24">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-300 text-sm font-medium tracking-wide uppercase mb-2" data-id="element-25">
          <Sparkles className="w-4 h-4" data-id="element-26" />
          <span data-id="element-27">Edición Maestro</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight text-glow" data-id="element-28">
          ¿Sentís tu casa "pesada", tu economía trabada o que la envidia ajena
          no te deja avanzar?
        </h1>

        <div className="relative max-w-2xl mx-auto" data-id="element-29">
          <div className="absolute -inset-4 bg-amber-500/15 blur-2xl rounded-full opacity-60" data-id="element-30"></div>
          <img src={REVELATION_IMG} alt="Elementos naturales de limpieza energética en el hogar" className="relative rounded-2xl shadow-2xl border border-amber-500/20 object-cover w-full aspect-[16/10]" data-id="element-31" />
        </div>

        <p className="text-xl md:text-2xl text-slate-300 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-32">
          <strong className="text-amber-400 font-semibold" data-id="element-33">
            Blindá tu Hogar, Protegé a tu Familia y Recuperá tu Suerte en 48
            Horas.
          </strong>
          <br className="hidden md:block" data-id="element-34" />
          El Protocolo Ancestral de Limpieza y Alta Protección que detiene la
          negatividad de raíz. Sin materiales caros, desde tu propia cocina.
        </p>

        <div className="pt-4" data-id="element-35">
          <CTAButton text="SÍ, QUIERO MI ACCESO AL SANTUARIO BLINDADO" data-id="element-36" />
          <p className="mt-3 text-sm text-slate-400 flex items-center justify-center gap-2" data-id="element-37">
            <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-38" />
            Acceso inmediato • Pago 100% seguro
          </p>
        </div>
      </div>
    </section>;
}
function HookSection() {
  const painPoints = ['Discusiones familiares explosivas que arruinan la paz del hogar.', "Electrodomésticos que se queman o el auto con fallas mecánicas 'fantasma'.", 'Una sensación de cansancio extremo que no se va ni durmiendo 8 horas.', 'La sospecha constante de que la envidia de otros está bloqueando tu progreso.'];
  return <section className="py-12 px-4 bg-slate-900 relative border-t border-amber-900/30" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <div className="text-center mb-8" data-id="element-41">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-amber-400" data-id="element-42">
            No es casualidad... es ENERGÍA estancada.
          </h2>
          <p className="text-xl text-slate-300" data-id="element-43">
            ¿Alguna vez sentiste que, por más que te esfuerces, siempre pasa
            "algo" que te tira para atrás?
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-44">
          {painPoints.map((point, idx) => <div key={idx} className="flex items-start gap-4 p-5 rounded-xl bg-slate-950/50 border border-slate-800 hover:border-amber-500/30 transition-colors" data-id="element-45">
              <div className="mt-1 bg-red-500/10 p-2 rounded-full border border-red-500/20 shrink-0" data-id="element-46">
                <AlertTriangle className="w-5 h-5 text-red-400" data-id="element-47" />
              </div>
              <p className="text-slate-300 leading-relaxed" data-id="element-48">{point}</p>
            </div>)}
        </div>

        <div className="p-6 rounded-2xl bg-gradient-to-br from-slate-800 to-slate-950 border border-amber-500/20 text-center relative overflow-hidden" data-id="element-49">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent opacity-50" data-id="element-50"></div>
          <p className="text-lg md:text-xl text-slate-200 leading-relaxed" data-id="element-51">
            En Argentina, la tensión social y la envidia actúan como una{' '}
            <strong className="text-amber-400 font-normal" data-id="element-52">"nube negra"</strong>{' '}
            que se pega a las paredes de tu casa y a los asientos de tu auto. Si
            no sabés cómo cortar esa frecuencia, la negatividad de los demás
            tiene la puerta abierta a lo más sagrado que tenés: tu familia.
          </p>
        </div>
      </div>
    </section>;
}
function RevelationSection() {
  return <section className="py-12 px-4 bg-slate-950 relative" data-id="element-53">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-54">
        <h2 className="text-3xl md:text-5xl font-bold text-amber-400 leading-tight" data-id="element-55">
          Dejá de ser una "esponja" de malas vibras y tomá el control.
        </h2>

        <div className="space-y-4 text-lg text-slate-300 max-w-3xl mx-auto text-left md:text-center" data-id="element-56">
          <p data-id="element-57">
            Descubrí el método{' '}
            <strong className="text-white font-serif text-xl tracking-wide" data-id="element-58">
              SANTUARIO BLINDADO
            </strong>
            . No es un libro de teorías místicas; es un Manual de Operaciones
            Energéticas.
          </p>
          <p data-id="element-59">
            Aprendé a usar elementos milenarios —
            <span className="text-amber-200" data-id="element-60">
              sal gruesa, vinagre, ruda y laurel
            </span>
            — como herramientas de alta precisión para disolver larvas
            energéticas, cortar el mal de ojo y sellar tu campo áurico.
          </p>
          <p className="text-xl text-white font-medium border-l-4 border-amber-500 pl-4 py-2 text-left" data-id="element-61">
            Es hora de recuperar la luz de tu casa y la fluidez de tu vida.
          </p>
        </div>
      </div>
    </section>;
}
function TestimonialSection() {
  const testimonials = [{
    title: 'Cambio total en 24 horas',
    text: 'Hice la limpieza de vinagre y sal y mi casa cambió por completo. Las peleas con mi marido pararon y los chicos volvieron a dormir tranquilos. Vale cada centavo por la paz que recuperamos.',
    author: 'Adriana M.',
    location: 'Buenos Aires'
  }, {
    title: 'Mi herramienta de trabajo está protegida',
    text: "El ritual del auto me salvó. Sentía que el coche estaba 'empavado' y vivía en el mecánico. Ahora manejo relajado, el auto anda perfecto y el trabajo fluye mejor que nunca.",
    author: 'Jorge D.',
    location: 'Mendoza'
  }, {
    title: 'Corté la racha de mala suerte',
    text: 'Sentía una pesadez constante y nada me salía bien en el trabajo. Apliqué el Escudo Dorado y el Baño Abre Caminos; a los tres días me llamaron para el proyecto que tanto esperaba.',
    author: 'Lorena S.',
    location: 'Rosario'
  }, {
    title: 'Ideal para proteger a los chicos',
    text: 'Como mamá, siempre temía la envidia ajena hacia mis hijos. El Protocolo de Blindaje me dio la herramienta para salir a la calle confiada. Siento a mi familia protegida y con otra energía.',
    author: 'Mónica G.',
    location: 'Córdoba'
  }];
  return <section className="py-12 px-4 bg-slate-900 border-y border-amber-900/30" data-id="element-62">
      <div className="max-w-6xl mx-auto" data-id="element-63">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 text-white" data-id="element-64">
          Familias que ya{' '}
          <span className="text-amber-400" data-id="element-65">Blindaron su Hogar</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-66">
          {testimonials.map((t, idx) => <div key={idx} className="bg-slate-950/80 p-6 rounded-2xl border border-amber-500/20 box-glow relative" data-id="element-67">
              <div className="flex gap-1 mb-3" data-id="element-68">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-69" />)}
              </div>
              <h3 className="text-xl font-bold text-amber-300 mb-2 font-serif" data-id="element-70">
                "{t.title}"
              </h3>
              <p className="text-slate-300 mb-4 italic leading-relaxed" data-id="element-71">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-72">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center border border-amber-500/30" data-id="element-73">
                  <span className="text-amber-400 font-bold" data-id="element-74">
                    {t.author.charAt(0)}
                  </span>
                </div>
                <div data-id="element-75">
                  <p className="font-bold text-white" data-id="element-76">{t.author}</p>
                  <p className="text-sm text-slate-400" data-id="element-77">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function OfferSection() {
  const bonuses = [{
    title: 'Protocolo de Emergencia para el Auto',
    desc: 'Limpieza rápida para vehículos.'
  }, {
    title: 'Kit de Endulzamiento Express',
    desc: 'Para restaurar vínculos sanos en casa.'
  }, {
    title: 'Checklist de Larvas Energéticas',
    desc: 'Auditoría completa de tu hogar.'
  }, {
    title: 'Hoja de Ruta de Hierbas y Elementos',
    desc: 'Guía rápida de uso.'
  }, {
    title: 'El Escudo Dorado',
    desc: 'Meditación guiada de 5 minutos.'
  }];
  return <section id="oferta" className="py-12 px-4 bg-slate-950 relative overflow-hidden scroll-mt-16" data-id="element-78">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-79"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-80">
        <div className="bg-gradient-to-b from-slate-900 to-slate-950 rounded-3xl border border-amber-500/30 p-6 md:p-10 box-glow" data-id="element-81">
          <div className="text-center mb-6" data-id="element-82">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-83">
              Llevate hoy el SISTEMA COMPLETO de Protección Total
            </h2>
            <p className="text-amber-400 text-xl font-serif" data-id="element-84">
              Edición Digital de Acceso Inmediato
            </p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-85">
            <div className="flex items-start gap-4 p-4 rounded-xl bg-amber-500/10 border border-amber-500/20" data-id="element-86">
              <CheckCircle2 className="w-6 h-6 text-amber-400 shrink-0 mt-1" data-id="element-87" />
              <div data-id="element-88">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-89">
                  📘 Manual Maestro: Santuario Blindado
                </h3>
                <p className="text-slate-300" data-id="element-90">
                  Tu guía paso a paso con todos los rituales y protocolos de
                  limpieza profunda.
                </p>
              </div>
            </div>

            <div className="pl-4 md:pl-8 space-y-3" data-id="element-91">
              <h4 className="text-lg font-bold text-slate-200 flex items-center gap-2 mb-3" data-id="element-92">
                <Gift className="w-5 h-5 text-amber-400" data-id="element-93" />
                Bonos Exclusivos (GRATIS hoy):
              </h4>
              {bonuses.map((bono, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-94">
                  <Sparkles className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-95" />
                  <p className="text-slate-300" data-id="element-96">
                    <strong className="text-white" data-id="element-97">
                      Bono {idx + 1}: {bono.title}
                    </strong>{' '}
                    —{' '}
                    <span className="text-amber-400/80 text-sm font-bold tracking-wide uppercase" data-id="element-98">
                      ¡GRATIS!
                    </span>
                  </p>
                </div>)}
            </div>
          </div>

          <div id="precio" className="border-t border-slate-800 pt-6 text-center space-y-4 scroll-mt-20" data-id="element-99">
            <div className="space-y-1" data-id="element-100">
              <p className="text-slate-400 line-through text-lg" data-id="element-101">
                VALOR TOTAL DEL PAQUETE: $56.000
              </p>
              <div className="flex flex-col items-center justify-center" data-id="element-102">
                <span className="text-sm text-amber-400 font-bold tracking-widest uppercase mb-1" data-id="element-103">
                  Precio de Lanzamiento
                </span>
                <div className="flex items-start justify-center gap-1" data-id="element-104">
                  <span className="text-3xl font-bold text-white mt-1" data-id="element-105">$</span>
                  <span className="text-6xl md:text-7xl font-bold text-white text-glow" data-id="element-106">
                    19.999
                  </span>
                  <span className="text-xl text-slate-400 mt-auto mb-2 ml-1" data-id="element-107">
                    ARS
                  </span>
                </div>
              </div>
              <p className="text-slate-400 text-sm" data-id="element-108">
                (Un solo pago, acceso de por vida al material digital).
              </p>
            </div>

            <div className="pt-2" data-id="element-109">
              <CTAButton text="SÍ, QUIERO MI ACCESO AL SANTUARIO BLINDADO" data-id="element-110" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function FAQSection() {
  const faqs = [{
    q: '¿Es difícil de aplicar si no sé nada de estos temas?',
    a: 'Absolutamente no. Los protocolos están diseñados para ser aplicados por cualquier persona, con instrucciones claras y directas.'
  }, {
    q: '¿Tengo que comprar materiales costosos en santerías?',
    a: 'No. El 90% de lo que necesitás ya está en tu cocina: sal, vinagre, canela, miel y ruda que conseguís en cualquier verdulería.'
  }, {
    q: '¿Esto es magia negra o algo peligroso?',
    a: 'Para nada. Es magia blanca de luz basada en elementos naturales. El objetivo es limpiar, armonizar y proteger, nunca dañar a terceros.'
  }, {
    q: '¿En cuánto tiempo noto los resultados?',
    a: "La mayoría de las personas siente un cambio en la 'vibración' y la claridad de su hogar a las pocas horas de realizar la primera limpieza profunda."
  }, {
    q: '¿Cómo recibo el material una vez que pago?',
    a: 'Al confirmar el pago, recibís un acceso inmediato a tu casilla de email para descargar el Manual Maestro y todos los Bonos en formato PDF para leer en tu cel o compu.'
  }, {
    q: '¿Qué pasa si siento que no es para mí?',
    a: 'Tenés 7 días de garantía. Si aplicás los métodos y no sentís una mejora real en tu entorno, te devolvemos el dinero sin preguntas.'
  }];
  return <section className="py-12 px-4 bg-slate-900 border-t border-amber-900/30" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 text-white" data-id="element-113">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-114">
          {faqs.map((faq, idx) => <div key={idx} className="bg-slate-950/50 border border-slate-800 rounded-xl p-5 hover:border-amber-500/30 transition-colors" data-id="element-115">
              <h3 className="text-xl font-bold text-amber-400 mb-2 flex items-start gap-3" data-id="element-116">
                <span className="text-slate-600 font-serif" data-id="element-117">{idx + 1}.</span>
                {faq.q}
              </h3>
              <p className="text-slate-300 leading-relaxed pl-7" data-id="element-118">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}
function GuaranteeSection() {
  return <section className="py-10 px-4 bg-slate-950 relative" data-id="element-119">
      <div className="max-w-4xl mx-auto text-center" data-id="element-120">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-amber-500/10 border border-amber-500/30 mb-4" data-id="element-121">
          <ShieldCheck className="w-12 h-12 text-amber-400" data-id="element-122" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 font-serif" data-id="element-123">
          Garantía de Hierro por 7 Días
        </h2>
        <p className="text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-124">
          El riesgo es todo mío. Si aplicás los protocolos y tu casa no se
          siente más liviana, o tu energía más alta,{' '}
          <strong className="text-amber-400" data-id="element-125">
            te devolvemos el 100% de la inversión
          </strong>
          . Sin preguntas, sin trabas.
        </p>
      </div>
    </section>;
}
function FooterCTA() {
  return <footer className="py-12 px-4 bg-gradient-to-b from-slate-900 to-black border-t border-amber-900/30 text-center relative overflow-hidden" data-id="element-126">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-127"></div>

      <div className="max-w-3xl mx-auto relative z-10 space-y-4" data-id="element-128">
        <h2 className="text-4xl md:text-5xl font-bold text-amber-400 font-serif" data-id="element-129">
          Tu Santuario te está esperando.
        </h2>
        <p className="text-xl text-slate-300 leading-relaxed" data-id="element-130">
          No permitas que una energía pesada que no te pertenece siga frenando
          tu prosperidad y la paz de tu familia. Tomá el control hoy mismo antes
          de que el contador llegue a cero.
        </p>

        <div className="pt-4" data-id="element-131">
          <CTAButton text="SÍ, QUIERO MI ACCESO AL SANTUARIO BLINDADO" data-id="element-132" />
        </div>

        <div className="pt-8 text-slate-600 text-sm" data-id="element-133">
          <p data-id="element-134">
            © {new Date().getFullYear()} Santuario Blindado. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-135">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </div>
    </footer>;
}
// Reusable CTA Button Component
function CTAButton({
  text
}: {
  text: string;
}) {
  return <a href="https://pagos.romahome.shop/cart/48885114700018:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg md:text-xl font-bold text-slate-950 bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-500 rounded-full overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_40px_rgba(251,191,36,0.4)] focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2 focus:ring-offset-slate-900 no-underline pl-[3px] pr-[3px]" data-id="element-136">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-137"></div>
      <span className="relative flex items-center gap-3" data-id="element-138">
        {text}
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-139" />
      </span>
    </a>;
}